export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 md:py-32 bg-[#f7f6f3]"
    >
      <div className="container mx-auto px-4 md:px-8 max-w-4xl">
        <div className="text-center mb-14">
          <p
            className="text-sm uppercase tracking-[0.3em] text-[#1a7a7a] mb-4 font-medium"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            The Firm
          </p>
          <h2
            className="text-4xl md:text-5xl font-semibold tracking-tight text-[#1a1a1a]"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            About Global Citizen Consulting
          </h2>
        </div>

        <div className="max-w-3xl mx-auto space-y-6 text-gray-500 text-base leading-relaxed" style={{ fontFamily: "'Montserrat', sans-serif" }}>
          <p>
            We work with founders, executives, and family offices to design how their lives work across borders. Where they live for tax purposes. Where they hold citizenship. Where their capital sits. Where their companies are based. And how all of it holds up over the next twenty years.
          </p>
          <p>
            We do not sell programs. We do not have a preferred jurisdiction. Our work begins with you, not the product. Sometimes the right answer is to change nothing. We will tell you when it is.
          </p>
        </div>
      </div>
    </section>
  );
}
